import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a0d0e85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid h-100 p-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row login" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mt-5" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Se connecter")
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1))
const _hoisted_5 = { class: "col col-lg-3 text-start fw-bold" }
const _hoisted_6 = { class: "row mt-4" }
const _hoisted_7 = { class: "row m-2" }
const _hoisted_8 = { class: "col form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputEmail" }, "Email : ", -1))
const _hoisted_10 = { class: "row m-2" }
const _hoisted_11 = { class: "col form-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "inputPassword" }, "Mot de passe : ", -1))
const _hoisted_13 = {
  id: "forgottentPassword fw-light",
  class: "form-text mt-1 row"
}
const _hoisted_14 = { class: "mb-3 row ms-2 form-check" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleCheck1"
}, "Rester connecté", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary"
    }, " Se connecter ")
  ])
], -1))
const _hoisted_18 = { class: "row m-2 mt-4" }
const _hoisted_19 = { class: "col text-center" }
const _hoisted_20 = { class: "text-danger" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResetPassword = _resolveComponent("ResetPassword")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_ResetPassword, { onCloseResetPasswordModal: _ctx.toggleResetPasswordModal }, null, 8, ["onCloseResetPasswordModal"]), [
      [_vShow, _ctx.showResetPasswordModal]
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "inputEmail",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  id: "inputPassword",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "col",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleResetPasswordModal && _ctx.toggleResetPasswordModal(...args)))
                  }, "Mot de passe oublié?"),
                  _createVNode(_component_RouterLink, {
                    class: "col text-end",
                    to: "/register"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("S'inscrire")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "exampleCheck1",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.persistentLogin) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.persistentLogin]
                ]),
                _hoisted_16
              ])
            ]),
            _hoisted_17
          ], 32)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.errorMsg), 1)
          ])
        ], 512), [
          [_vShow, _ctx.errorMsg]
        ])
      ]),
      _hoisted_21
    ])
  ]))
}